import { ActionGroup } from "@mittwald/flow-remote-react-components";
import { Button } from "@mittwald/flow-remote-react-components";
import { Content } from "@mittwald/flow-remote-react-components";
import { OverlayController } from "@mittwald/flow-remote-react-components";
import { Heading } from "@mittwald/flow-remote-react-components";
import { Modal } from "@mittwald/flow-remote-react-components";
import { useDeleteUser } from "../../hooks/useDeleteUser";
import { Text } from "@mittwald/flow-remote-react-components";

export const DeleteUserModal = (props: {
  username: string;
  controller: OverlayController;
  projectId: string;
}) => {
  const deleteUserMutation = useDeleteUser(props.projectId);

  return (
    <Modal controller={props.controller} size="s">
      <Heading>Benutzer löschen</Heading>
      <Content>
        <Text>
          Möchtest du den Benutzer <strong>{props.username}</strong> wirklich
          löschen und somit aus allen Passwortschutzen entfernen?
        </Text>
      </Content>
      <ActionGroup>
        <Button
          color="danger"
          isPending={deleteUserMutation.isPending}
          isSucceeded={deleteUserMutation.isSuccess}
          onPress={() => {
            void deleteUserMutation.mutateAsync(props.username).then(() => {
              props.controller.close();
              deleteUserMutation.reset();
            });
          }}
        >
          Benutzer löschen
        </Button>
        <Button
          color="secondary"
          variant="soft"
          onPress={() => {
            props.controller.close();
          }}
        >
          Abbrechen
        </Button>
      </ActionGroup>
    </Modal>
  );
};
